import * as React from 'react'
import moment from 'moment'
import { MetricsContainerLoadSpin } from '../../../AnalyticsMetric/components/Spin'
import {  GlobalFilterSelector } from '../common'
import Feature from '../../../../modules/common/components/Feature'
import Section from "../../../core/Section"; import { MetricsContainer } from '../'
import {generateQueryString, parseQueryString, hostedMerchants} from '../../../../modules/common/utils'
import './styles.scss'
import { MerchantBadge, QuerySelector } from '../../../common'
import { defaultGroupBy, defaultView, validateDropDowns, hasFinancePermissions} from '../../../AnalyticsMetric/constants'
import { TermsOfService } from './terms_of_service'
import { sendGAEvent, ViewContext } from '../../../common/google_analytics'
import { AnalyticsGlobalFilters , defaultGlobalFilters, validateGlobalFilters} from "../../constants"
import { AnalyticsContainerActions , AnalyticsMetricContainerProps } from './container'

import _ from 'lodash'
import {UpdateInfoModal} from '../../../core/Modal';

const supportedMetrics = [
  'spend',
  'impressions',
  'opens',
  'unique_engaged_visits',
  'clicks',
  'shopping_list',
  'ttm',
  'time_on_flyer',
  'item_views',
]

type Props =  AnalyticsContainerActions & AnalyticsMetricContainerProps & RouterChildProps;
interface State {
  isHostedModalOpen: boolean;
  isTOSModalOpen: boolean;
  isUpdatesInfoModalOpen: boolean;
  isOneAppMerchant: boolean;
}

class AnalyticsMetricContainer extends React.Component <Props, State>{
  constructor() {
    super();
    this.state = {
      isHostedModalOpen: true,
      isTOSModalOpen: true,
      isUpdatesInfoModalOpen: true,
      isOneAppMerchant: false,
    }
  }

  closeHostedModal = () => {
    this.setState({ isHostedModalOpen: false })
  }

  closeTOSModal = () => {
    this.setState({ isTOSModalOpen: false })
  }

  closeUpdatesInfoModal = () => {
    this.setState({ isUpdatesInfoModalOpen: false })
  }

  prohibitFutureDateSelect = (date: any) => { return moment(date).isBefore(moment().startOf('day')) }

  dateLimit = () => {
    return this.props.features["analytics_dashboard_24_months"] ? 24 : 16
  }

  validateDate = (date: any) => {
    return moment(date).isAfter(moment().subtract(this.dateLimit(), 'months'))
  }

  componentDidUpdate(prevState: any) {
    if (prevState.isOneAppMerchant !== this.state.isOneAppMerchant) {
      this.syncUrl()
    }
  }

  getData() {
    let metricsGroup = supportedMetrics

    if(this.props.location.search){

      //initialize props from URL
      const query_props = parseQueryString(this.props.location.search)

      if(!hasFinancePermissions(this.props.permissions, query_props.merchant)) {
        metricsGroup = supportedMetrics.filter((metric: string) => metric != 'spend')
      }

      if(query_props.start_date && query_props.end_date && query_props.merchant && query_props.flyer_run_ids && this.props.merchants.length > 0){
        this.props.getAggregatedMetrics(
          query_props.flyer_run_ids.map((id:string)=>{return parseInt(id)}),
          parseInt(query_props.merchant),
          query_props.start_date,
          query_props.end_date,
          metricsGroup
        )
      }

    } else{
      this.props.setMetricSelection('impressions', this.props.merchant_id)
      if(!hasFinancePermissions(this.props.permissions, this.props.merchant_id)) {
        metricsGroup = supportedMetrics.filter((metric: string) => metric != 'spend')
      }
      if(this.props.merchant_id && this.props.publication_ids && this.props.start_date && this.props.end_date){
        this.props.getAggregatedMetrics(
          this.props.publication_ids,
          this.props.merchant_id,
          this.props.start_date,
          this.props.end_date,
          metricsGroup
        )
      }
    }

    // Update redux tree with new params from url.
    // HACK: This has to be done after getting aggregate metrics to
    // avoid issues with the back-button.
    this.syncUrl()

    this.props.getAnalyticsMerchants('#')
  }

  syncUrl = () => {
    let query_props = parseQueryString(this.props.location.search)

    query_props = this.normalizeSearchQuery(query_props)
    query_props = this.validateSearchQuery(query_props)

    if(!moment(query_props.start_date).isAfter(query_props.end_date)) {
      if(this.prohibitFutureDateSelect(query_props.end_date) && this.validateDate(query_props.end_date))
        this.props.setEndDate(query_props.end_date)
      if(this.prohibitFutureDateSelect(query_props.start_date) && this.validateDate(query_props.start_date))
        this.props.setStartDate(query_props.start_date)
    }
    this.setOneAppMerchantState(this.props.merchants, this.props.merchant_id);

    const globalFilters = { device: query_props.deviceFilters, channel: query_props.channelFilters }

    if(this.state.isOneAppMerchant) {
        globalFilters.channel = globalFilters.channel.filter((value: string) => value !== "distribution")
    }

    this.props.setMerchantSelection(query_props.merchant ? parseInt(query_props.merchant): null)
    this.props.setMetricSelection(query_props.metric, query_props.merchant ? parseInt(query_props.merchant): null)

    this.props.setPublicationSelection(query_props.flyer_run_ids? query_props.flyer_run_ids.map((id:string)=>{return parseInt(id)}) : null)
    this.props.setMetricContentCompareBy(query_props.compare_by)
    this.props.setMetricContentGroupBy(query_props.group_by)
    this.props.setMetricContentView(query_props.view)
    this.props.setGlobalFiltersSelection(globalFilters)
    this.props.clearMetricData()
    return query_props
  }

  normalizeSearchQuery = (query_props: any) => {
    const metric = query_props.metric || 'impressions'
    const view = query_props.view || defaultView(metric)
    const group_by = query_props.group_by || defaultGroupBy(metric, view)
    const deviceFilters = query_props.deviceFilters || defaultGlobalFilters.device
    const channelFilters = query_props.channelFilters || defaultGlobalFilters.channel
    return { ...query_props, metric, view, group_by, deviceFilters, channelFilters }
  }

  validateSearchQuery = (query_props: any) => {
    let { metric, group_by, compare_by, view, deviceFilters, channelFilters } = query_props
    const globalFilters = { device: deviceFilters, channel: channelFilters }
    const validDropdowns = validateDropDowns(metric, group_by, compare_by, view)
    const validGlobalFilters = validateGlobalFilters(globalFilters)

    if(!validDropdowns || !validGlobalFilters){
      if (!validDropdowns) {
        view = defaultView(metric)
        compare_by= null
        group_by = defaultGroupBy(metric, view)

        query_props.view = view
        delete query_props.compare_by
        query_props.group_by = group_by
      }
      if (!validGlobalFilters) {
        query_props.deviceFilters = defaultGlobalFilters.device
        query_props.channelFilters = defaultGlobalFilters.channel
      }

      let queryString = `?${generateQueryString(query_props)}`
      this.props.history.replace(queryString)
    }

    return { ...query_props, metric, view, group_by, deviceFilters, channelFilters }
  }

  componentWillMount(){
    this.getData()
  }

  componentDidMount() {
    let __this = this;
    window.addEventListener('popstate', function(e) {
      __this.getData()
    });
  }

  componentWillReceiveProps(nextProps:Props){
    let metricsGroup = supportedMetrics
    if(!hasFinancePermissions(this.props.permissions, nextProps.merchant_id))  {
        metricsGroup = supportedMetrics.filter((metric: string) => metric != 'spend')
    }

    if(nextProps.merchant_id && nextProps.start_date && nextProps.end_date && nextProps.publication_ids && nextProps.publication_ids.length>0)

    if(this.props.merchant_id != nextProps.merchant_id ||
      (_.differenceWith(this.props.publication_ids, nextProps.publication_ids, _.isEqual).length>0)||
      !_.isEqual(_.sortBy(this.props.globalFilters.device), _.sortBy(nextProps.globalFilters.device))||
      !_.isEqual(_.sortBy(this.props.globalFilters.channel), _.sortBy(nextProps.globalFilters.channel))||
      this.props.start_date != nextProps.start_date ||
        this.props.end_date != nextProps.end_date){
          this.props.getAggregatedMetrics(
            nextProps.publication_ids,
            nextProps.merchant_id,
            nextProps.start_date,
            nextProps.end_date,
            metricsGroup
        )
      }
    //Should clear query string once once an invalid merchant input is present
    if(!nextProps.merchant_id && this.props.merchant_id != nextProps.merchant_id){
      this.props.history.push('')
    }
  }

  shouldComponentUpdate(nextProps: Props, nextState: State){
    return (this.props.merchant_id != nextProps.merchant_id ||
      this.props.merchants != nextProps.merchants ||
      (_.differenceWith(this.props.publication_ids, nextProps.publication_ids, _.isEqual).length>0)||
      !_.isEqual(_.sortBy(this.props.globalFilters.device), _.sortBy(nextProps.globalFilters.device))||
      !_.isEqual(_.sortBy(this.props.globalFilters.channel), _.sortBy(nextProps.globalFilters.channel))||
      this.props.start_date != nextProps.start_date ||
      this.props.end_date != nextProps.end_date ||
      this.props.publications_loading != nextProps.publications_loading ||
      this.props.analytics_metrics_loading != nextProps.analytics_metrics_loading ||
      this.state.isHostedModalOpen !== nextState.isHostedModalOpen ||
      this.state.isTOSModalOpen !== nextState.isTOSModalOpen ||
      this.state.isUpdatesInfoModalOpen !== nextState.isUpdatesInfoModalOpen
      )
  }
  renderContainerContents(){
    let {clicks, impressions, item_views} = this.props.analytics_metrics
    let nullAggregatedMetrics = clicks == null && impressions == null && item_views == null
    let {analytics_metrics_loading} = this.props
    let contents = null

    if(!nullAggregatedMetrics && !analytics_metrics_loading && this.props.merchant_id){
      contents = <Section><MetricsContainer /></Section>
    }
    else if(analytics_metrics_loading && this.props.merchant_id){
      contents = <MetricsContainerLoadSpin/>
    }
    else{
      contents = <Section> {this.renderEmptyContainer()} </Section>
    }

    return contents
  }

  renderEmptyContainer(){
    return (
      <div style={{display:"block",textAlign:"center",height:500,paddingTop:240}}>
        <img src='/flipp_empty.png' style={{height:200,marginBottom:100,marginTop:-100}}/>
      </div>
    )
  }

  updateGlobalFilters = (globalFilters: AnalyticsGlobalFilters) => {
    this.props.setGlobalFiltersSelection(globalFilters)

    // Send GA Event
    const devices = globalFilters.device.join(', ')
    const channels = globalFilters.channel.join(', ')
    const newViewContext = {...this.props.gaViewContext, deviceFilters: devices, channelFilters: channels}
    sendGAEvent('Analytics', 'Apply Filters', this.props.currentMerchantName,
      { ...this.props.gaUserContext, ...newViewContext}
    )

    // Update URL
    const deviceFilters = globalFilters.device
    const channelFilters = globalFilters.channel
    const queryProps = parseQueryString(this.props.location.search)
    const newQueryProps = { ...queryProps, deviceFilters, channelFilters }
    const queryString = `?${generateQueryString(newQueryProps)}`
    this.props.history.push(queryString)
  }

  handleQuerySelectorSubmition(publicationIds:number[], startDate:string, endDate:string, merchantId:number){
    this.props.setPublicationSelection(publicationIds)
    this.props.setMerchantSelection(merchantId);
    this.props.setStartDate(startDate)
    this.props.setEndDate(endDate)

    let metrics = hasFinancePermissions(this.props.permissions, merchantId) ? supportedMetrics : supportedMetrics.filter((metric: string) => metric != 'spend')
//check for finance access and fetch data
    this.props.getAggregatedMetrics(
        publicationIds,
        merchantId,
        startDate,
        endDate,
        metrics
    )

    //Update URL
    let queryProps = parseQueryString(this.props.history.location.search)
    const queryString = generateQueryString({...queryProps,
      flyer_run_ids: publicationIds,
      start_date: startDate,
      end_date: endDate,
      merchant: merchantId})
    this.props.history.push(`?${queryString}`)

    //GA Beacons
    const { gaUserContext } = this.props
    const viewContext: ViewContext = { startDate, endDate, numPublications: `${publicationIds.length}`}
    const merchantName = this.props.merchants.find((merch: any) => merch.id == merchantId).name
    sendGAEvent('Analytics', 'Show Data', merchantName, {...gaUserContext, ...viewContext})
  }

  setOneAppMerchantState(merchants: any, merchantId: number) {
    const merchant = merchants.find((merchant: any) => merchant.id === merchantId);

    if(!merchant) return;

    this.setState({ isOneAppMerchant: merchant.one_app_platform })
  };

  render(){
    let merchants = (this.props.merchants) ? this.props.merchants : []
    let selectedMerchant = merchants.length == 1 ?  merchants[0] : merchants.find((i: any) => i.id == this.props.merchant_id)
    let {clicks, impressions, item_views} = this.props.analytics_metrics
    let nullAggregatedMetrics = clicks == null && impressions == null && item_views == null
    let {analytics_metrics_loading} = this.props
    let { globalFilters } = this.props

    // Query Selector props are in CamelCase
    const publicationIds = this.props.publication_ids
    const merchantId = selectedMerchant ? selectedMerchant.id : null
    const startDate = this.props.start_date
    const endDate = this.props.end_date
    const querySelectorProps = { publicationIds, merchantId, startDate, endDate}
    const haveHostedMerchants =
      this.props.merchants.filter((merchant) =>
        hostedMerchants.some(({ merchant_id }) => merchant_id === merchant.id)
      ).length > 0;

    return(
      <div className='analytics-container'>
        <div className="analytics-metric-container-body" >
          <TermsOfService
            visible={this.state.isTOSModalOpen}
            onClose={this.closeTOSModal}
          />
          <UpdateInfoModal
            visible={false}
            onClose={this.closeUpdatesInfoModal}
          />
          <div className="section selector-wrapper">
            <MerchantBadge selectedMerchant={selectedMerchant}/>
            <div className='right-section'>
              <Feature flag="analytics_global_filter">
                <GlobalFilterSelector isOneApp={this.state.isOneAppMerchant} globalFilters={globalFilters} setGlobalFilters={this.updateGlobalFilters}/>
              </Feature>
              <QuerySelector {...this.props} {...querySelectorProps} selectedMerchant={selectedMerchant} handleSubmit={(publicationIds:number[], startDate:string, endDate:string, merchantId:number)=>{this.handleQuerySelectorSubmition(publicationIds, startDate, endDate, merchantId)}} dateSelectionLimit={this.dateLimit()}/>
            </div>
          </div>
          {this.renderContainerContents()}
        </div>
      </div>
    )
  }
}

export default AnalyticsMetricContainer



// WEBPACK FOOTER //
// ./client/modules/Analytics/components/AnalyticsContainer/component.tsx